import { Providers } from "@/components/providers";
import { AppRoutes } from "@/router";

export function App() {
  return (
    <Providers>
      <AppRoutes />
    </Providers>
  );
}
